import { truncate } from "lodash";

const META_DESCRIPTION_MAX_LENGTH = 160;

/**
 * @description Meta description 길이를 최대 160자로 제한합니다.
 */
export function truncateMetaDescription(description: string) {
  return truncate(description.replace(/\n+/g, " ").trim(), {
    length: META_DESCRIPTION_MAX_LENGTH,
  });
}
